import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AnalyticsProvider } from '@/components/providers/AnalyticsProvider'
import './i18n'
import './index.css'
import App from './App.tsx'

// Add dark mode class to HTML element for Figma theme
document.documentElement.classList.add('dark')

// Create QueryClient with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 seconds
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Export for use in hooks (cache invalidation)
export { queryClient }

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AnalyticsProvider>
        <App />
      </AnalyticsProvider>
    </QueryClientProvider>
  </StrictMode>
)
